<template>
  <v-card outlined>
    <v-data-table
      :loading="loading"
      :items="topics"
      :headers="headers"
      disable-pagination
      hide-default-footer
      :sort-by="['name']"
      :sort-desc="[false]"
      :search="filter.search"
      mobile-breakpoint="0"
    >
      <template #[`item.popularity.ranking`]="{ item }">
        <v-select
          v-if="item.popularity"
          v-model="item.popularity.id"
          :items="popularity"
          outlined
          hide-details
          item-value="id"
          item-text="name"
          class="min-width"
          dense
          @change="savePopularity(item)"
        />
      </template>
      <template #[`item.active`]="{ item }">
        <v-icon
          small
          :color="item.active ? 'success' : 'grey lighten-1'"
          :title="item.active ? 'Active' : 'Retired'"
        >
          {{ item.active ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
        </v-icon>
      </template>
      <template #[`item.publishedCount`]="{ item }">
        {{ item.publishedCount | separator }}
      </template>
      <template #[`item.notPublishedCount`]="{ item }">
        {{ item.notPublishedCount | separator }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          class="mr-2"
          outlined
          @click="rowclick(item)"
        >
          Filter
        </v-btn>
        <v-btn :to="`/topics/${item.id}`"> Edit </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogTopics',
  components: {},
  data: () => {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Industry', value: 'industry.name' },
        // Unlike IndustriesController.GetAll, the topics list is deliberately UNFILTERED so retired topics
        // stay reachable to be un-retired — which means they need a visible cue.
        { text: 'Active', value: 'active' },
        { text: 'Popularity', value: 'popularity.ranking' },
        { text: 'Published', value: 'publishedCount' },
        { text: 'Not Published', value: 'notPublishedCount' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    ...mapGetters({
      topics: 'topics/list',
      popularity: 'lookup/popularity'
    })
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch('topics/load', this.filter),
      this.$store.dispatch('catalog/filter', Object.assign(this.filter, { topicId: null }))
    ])
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    rowclick(item) {
      this.$store
        .dispatch('catalog/filter', Object.assign(this.filter, { topicId: item.id }))
        .then(() => {
          this.$router.push({ path: '/catalog/designgroups' });
        });
    },
    savePopularity(item) {
      this.saving = true;
      this.$store
        .dispatch('topics/savePopularity', {
          id: item.id,
          popularityId: item.popularity.id
        })
        .then(() => {
          this.$root.$snackbarSuccess('Popularity saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
